import { CLabel } from '@coreui/react';
import * as React from 'react';
import { IComplements } from '../abstraction';

interface IProps {
    Control: IComplements;
}

// Affiche les trois compl�ments associ�s � une zone X3 (controle)
export class KComplements extends React.Component<IProps> {
    public constructor(props: any) {
        super(props);
    }

    render() {
        let c = this.props.Control;

        return (
            <div>
                <CLabel className={"KControlComplement KControlComplement1 " + c.Complement1CSS}>{c.Complement1}</CLabel>
                <CLabel className={"KControlComplement KControlComplement2 " + c.Complement2CSS}>{c.Complement2}</CLabel>
                <CLabel className={"KControlComplement KControlComplement3 " + c.Complement3CSS}>{c.Complement3}</CLabel>
            </div>
        );
    }
}
